import { FormField } from "../../../toolympus/components/ConfigurableForms/types";
import { useSingleSchema } from "../../../toolympus/hooks/useSchema";
import { useSmartList } from "../../../toolympus/hooks/useSmartList";

export interface Product {
  _id: string;
  title: string;
  created_at?: string;
  is_active?: boolean;
  price?: number;
  fields: FormField[];
}


export const ProductApiPath = "/api/product/admin/config";

export const useProductSchema = () => {
  const { schema } = useSingleSchema(`${ProductApiPath}/uiconfig`);
  return schema;
}


const ProductTextFilter = (r: Product) => `${r.title} ${r._id}`;

export const useProductList = () => {
  const schema = useProductSchema();

  // const assignedFilter = useBrowserStoredValue("me", undefined, "__mp_documents_my_all");

  const data = useSmartList(ProductApiPath, {
    sorting: {
      // disallowedFields: ["description"],
    },
    extraParams: {
      // assigned: assignedFilter.value === "me" ? "me" : undefined,
    },
    viewDefault: "all",
    lsKeysPrefix: "__pform_productlist",
    newRecordDefault: { title: "", fields: [] },
    schema,
    textFilterFn: ProductTextFilter,
  });

  return {
    ...data,
    // assignedFilter,
  }
  
}



export type ProductListData = ReturnType<typeof useProductList>;
